import { useEffect, useState } from 'react';
import { Group, HanThanhToan, KhachHang, KhuVuc, NhanVien, PhuongThucThanhToan, TaiKhoan } from '@/types/schemas';
import { FormMode } from '@/types/form';

type GeneralInfoTabFormMode = 'add' | 'edit' | 'view';

/**
 * Custom hook for managing the state of the GeneralInfoTab component
 * @returns State and setter functions for the GeneralInfoTab component
 */
export const useGeneralInfoState = (mode: FormMode = 'add', selectedObj?: KhachHang) => {
  const tabFormMode: GeneralInfoTabFormMode = mode === 'search' ? 'view' : mode;

  const [nhanVien, setNhanVien] = useState<NhanVien | null>(selectedObj?.sales_rep_data || null);
  const [nhomKH1, setNhomKH1] = useState<Group | null>(selectedObj?.customer_group1_data || null);
  const [nhomKH2, setNhomKH2] = useState<Group | null>(selectedObj?.customer_group2_data || null);
  const [nhomKH3, setNhomKH3] = useState<Group | null>(selectedObj?.customer_group3_data || null);
  const [taiKhoan, setTaiKhoan] = useState<TaiKhoan | null>(selectedObj?.account_data || null);
  const [khuVuc, setKhuVuc] = useState<KhuVuc | null>(selectedObj?.region_data || null);
  const [hanThanhToan, setHanThanhToan] = useState<HanThanhToan | null>(selectedObj?.payment_term_data || null);
  const [phuongThucThanhToan, setPhuongThucThanhToan] = useState<PhuongThucThanhToan | null>(
    selectedObj?.payment_method_data || null
  );

  // Update state when selectedObj changes
  useEffect(() => {
    if (selectedObj) {
      setNhanVien(selectedObj.sales_rep_data || null);
      setNhomKH1(selectedObj.customer_group1_data || null);
      setNhomKH2(selectedObj.customer_group2_data || null);
      setNhomKH3(selectedObj.customer_group3_data || null);
      setTaiKhoan(selectedObj.account_data || null);
      setKhuVuc(selectedObj.region_data || null);
      setHanThanhToan(selectedObj.payment_term_data || null);
      setPhuongThucThanhToan(selectedObj.payment_method_data || null);
    }
  }, [selectedObj]);

  return {
    formMode: tabFormMode,
    nhanVien,
    nhomKH1,
    nhomKH2,
    nhomKH3,
    taiKhoan,
    khuVuc,
    hanThanhToan,
    phuongThucThanhToan,
    setNhanVien,
    setNhomKH1,
    setNhomKH2,
    setNhomKH3,
    setTaiKhoan,
    setKhuVuc,
    setHanThanhToan,
    setPhuongThucThanhToan
  };
};
